export default __webpack_public_path__ + "static/media/54-min.32d8f000.png";